import React from 'react';

import roadSignImage from '../../../../assets/images/new-address.png';
import { Button } from '../../../../components/Button/Button';
import { useLanguage } from '../../../../locale/useLanguage';

import './EditAddressSuccess.css';

export type EditAddressSuccessProps = {
  hasNotes?: boolean;
  onBackToEdit: () => void;
  onTrackOrder: () => void;
};

export const EditAddressSuccess: React.FC<EditAddressSuccessProps> = ({
  hasNotes = false,
  onBackToEdit,
  onTrackOrder,
}) => {
  const [t] = useLanguage();

  return (
    <div className="edit-address-success--body">
      <div className="edit-address-success--content">
        <div className="edit-address-success--content-container">
          <img
            className="edit-address-success--image"
            src={roadSignImage}
            alt="Road sign"
          />
          <p className="subtitle edit-address-success--paragraph">
            {t('changeAddressFinalView.addressEdited')}
          </p>
        </div>
        <div>
          <Button
            isWhite
            onClick={onTrackOrder}
            label={t('changeAddressFinalView.trackYourOrder')}
          />
          <div className="edit-address-success--add-note">
            <Button
              onClick={onBackToEdit}
              label={
                hasNotes
                  ? t('changeAddressFinalView.backToEdit')
                  : t('changeAddressFinalView.addNotes')
              }
            />
          </div>
        </div>
      </div>
    </div>
  );
};
